import Config from "../config.json";

const baseURI = Config.baseURI;
const azureAppID = Config.azureAppID;
const authorityURI = Config.authorityURI;

// msal 1.x.x way of implementing the sso for vanilla js
const config = {
    cache: {
        cacheLocation: "localStorage", // this will enable sharing session between tabs
        storeAuthStateInCookie: true,
        claimsBasedCachingEnabled: true
    },
    auth: {
        redirectUri: baseURI,
        clientId: azureAppID,
        authority: authorityURI,
        navigateToLoginRequestUrl: false,
        postLogoutRedirectUri: baseURI + "/login"
    },
    system: {
        pollIntervalMilliseconds: 0
    }
}

const loginRequest = {
    scopes: ["openid", "profile", "user.read"],
}

const accessTokenRequest = {
    scopes: ["user.read"],
}

const graphEndpoint = {
    graphEndpoint: "https://graph.microsoft.com/v1.0/me"
}

export {
    config,
    loginRequest,
    accessTokenRequest,
    graphEndpoint,
};
